__webpack_require__.p = "https://app-staticfiles.blr1.cdn.digitaloceanspaces.com/talent/prod/releases/2-20260605-1746/";